import * as React from "react";
import { Table, TableBody, TableCell, TableRow } from "@/components/bp/bp-ui";
import { TranslationContext } from "../Contexts/TranslationContext";
import { ClientResources, ParameterTypes } from "@app/api2/api";
import { BPBoxWithHeader } from "@common/BPBoxWithHeader";
import { IParameterRenderer, IParamView, ParameterOwnerModel } from "./ParameterRendererAbstracts";

export interface ParametersViewProps {
    parameters: IParamView[];
    parameterRenderer: IParameterRenderer;
    model: ParameterOwnerModel;
    children?: (props: { parameters: Array<{ parameter: string, label: string, value: JSX.Element }> }) => any;
    forPrint?: boolean;
    secondaryParametersCollapsed?: boolean;
}

export class ParametersView extends React.Component<ParametersViewProps> {

    

    render() {
        // console.log(ParametersView)
        if (this.props.children) {
            return (<TranslationContext.Consumer>{t => {
                const parameters = this.props.parameters.sort((a, b) => a.order - b.order).filter(x => this.isRowVisible(x)).map(x => {
                    return { parameter: x.parameter, label: t.parameter.names[x.parameter], value: this.renderParameterView(x, t) }
                })

                return <>{this.props.children({ parameters: parameters })}</>
            }}</TranslationContext.Consumer>)
        } else {
            return (<TranslationContext.Consumer>{t =>
                <BPBoxWithHeader header={t.common.parameters} forPrint={this.props.forPrint}>
                    <Table definition striped>
                        <TableBody>
                            {this.props.parameters.sort((a, b) => a.order - b.order).map((p) => (
                                this.isRowVisible(p) && this.renderParameterRow(p, t)
                            ))}
                        </TableBody>
                    </Table>
                </BPBoxWithHeader>}
            </TranslationContext.Consumer>)
        };
    }

    private renderParameterRow(p: IParamView, t: ClientResources): JSX.Element {
        return <TableRow key={p.parameter}>
            <TableCell width={10}>{t.parameter.names[p.parameter]}</TableCell>
            <TableCell>{this.renderParameterView(p, t)}</TableCell>
        </TableRow>;
    }

    private renderParameterView(p: IParamView, t: ClientResources): JSX.Element {
        const hasCustomRenderer = this.props.parameterRenderer && this.props.parameterRenderer.canRenderParameter(p.parameter);
        return <>
            {hasCustomRenderer &&
                <span>
                    {this.props.parameterRenderer.renderParameterView({ model: this.props.model, p })}
                </span>}
            {(!hasCustomRenderer && (p.parameterType === ParameterTypes.Number || p.parameterType === ParameterTypes.Integer || p.parameterType === ParameterTypes.String || p.parameterType === ParameterTypes.Json)) &&
                p.value}
            {(!hasCustomRenderer && (p.parameterType === ParameterTypes.Boolean) && (p.value === "1" ? t.common.yes : t.common.no))}
        </>;
    }

    isRowVisible = (p: IParamView) => {
        if (this.props.secondaryParametersCollapsed && p.isSecondary)
            return false;

        if (p.userVisible != null && !p.userVisible) {
            return false;
        }
        if (!p.showIfChecked) {
            return true;
        }

        var fields = p.showIfChecked.split(',');

        var equalFields = fields.filter(x => x.indexOf('=') > -1).map(x => x.split('='))

        var falseFields = fields.filter(f => f.startsWith("!") && f.indexOf('=') == -1).map(m => m.slice(1))
        var trueFields = fields.filter(f => !f.startsWith("!") && f.indexOf('=') == -1)

        var values = this.props.parameters.reduce((dict, curr) => {
            dict[curr.parameter] = curr.value;
            return dict;
        }, {});

        return falseFields.reduce((show, field) => show && !(values[field] === "1"), true)
            && trueFields.reduce((show, field) => show && (values[field] === "1"), true)
            && equalFields.reduce((show, field) => show && (values[field[0]] == field[1]), true);
    };
}

